import {Callout} from '@wandb/weave/components/Callout';
import {type IconName} from '@wandb/weave/components/Icon';
import {type TagColorName} from '@wandb/weave/components/Tag';
import {kebabCase} from 'lodash';
import React from 'react';
import {twMerge} from 'tailwind-merge';

type WorkspaceModeOptionProps = {
  color: TagColorName;
  description: string;
  icon: IconName;
  isSelected: boolean;
  label: string;
  onClick: () => void;
};

export const WorkspaceModeOption = ({
  color,
  description,
  icon,
  isSelected,
  label,
  onClick,
}: WorkspaceModeOptionProps) => {
  const labelId = `${kebabCase(label)}-label`;
  return (
    <div
      role="radio"
      aria-checked={isSelected}
      aria-labelledby={labelId}
      className={twMerge(
        'w-[320px] cursor-pointer rounded-lg border border-wb-border bg-wb-surface p-32 text-center hover:shadow-flat',
        isSelected
          ? 'border-wb-accent outline outline-1 outline-wb-accent'
          : 'hover:border-wb-border-strong'
      )}
      onClick={onClick}>
      <Callout
        className="mx-auto mb-16"
        size="small"
        color={color}
        icon={icon}
      />
      <p id={labelId} className="mb-8 block text-lg font-semibold">
        {label}
      </p>
      <span className="text-sm text-wb-text-secondary">{description}</span>
    </div>
  );
};
